var STRONG_PASSWORD_MESSAGE = 'Your password must have at least one lowercase letter, one uppercase letter, one digit, one special character, and is at least eight characters long.';
var STRONG_PASSWORD_REGEXP = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/;

function isStrongPassword(password) {
  return STRONG_PASSWORD_REGEXP.test(password || '');
}

module.exports = {
  STRONG_PASSWORD_MESSAGE: STRONG_PASSWORD_MESSAGE,
  isStrongPassword: isStrongPassword
};
